import AppButton from "./AppButton";

export default AppButton;
export type { AppButtonProps } from "./AppButton";
